import { Component, OnInit } from '@angular/core';
import { UmsService } from '../ums.service';
import { ModalpopService } from '../modalpop.service';
import { HttpClient, HttpErrorResponse,HttpHeaders } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { MatDialogRef } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-cast-wise-intake',
  templateUrl: './cast-wise-intake.component.html',
  styleUrls: ['./cast-wise-intake.component.scss'],
})
export class CastWiseIntakeComponent implements OnInit {
  castIntake: FormGroup;
  isShownCourseList = false;
  isShownCollegeList = false;
  isShownCourseDiv = false;
  isShownCollegeDiv = false;
  isCollegeRadioBtn = false;
  isCourseRadioBtn = false;
  collegeList: any;
  filteredCollegeList: any;
  courseList: any;
  filteredCourseList: any;
  sessionList: any[];
  SessionFilterList: any[];
  categoryList: any[];
  filteredCategoryList: any[];
  CollegeCastArr: FormArray;
  dialogRef: MatDialogRef<any>;
  errMsg: any;
  arr = [];
  arrayy;
  CountTable: any;
  inteckCount: any;
  sessionId = 0;
  CoCode = 0;
  CgCode = 0;
  showCount = false;
  response: any;
  istableShow = false;
  tableData: any;
  inputTimeout: any;
  arrTest: any = [];
  totalCount = 0;
  submitButton = true;
  updateButton = false;
  buttonDisabled = false;
  showErr = false;
  Message;
  userPermission;
  utp: string;
  castCreate = true;
  castUpdate = true;
  APIService: string;
  constructor(
    public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private fb: FormBuilder,
    private httpClient: HttpClient,
    public router: Router,
    private spinner: NgxSpinnerService
  ) {
    this.APIService = environment.serviceUrl;
  }

  ngOnInit(): void {
    this.userPermission = JSON.parse(sessionStorage.getItem('userPermission'));
    this.utp = sessionStorage.getItem('usertypeee');
    if (this.utp !== 'Super Admin') {
      // this.isSuperAdmin= false;
      this.userPermission.forEach((element) => {
        if (
          element.PageName == 'Caste Wise Intake' &&
          element.PCreate == false
        ) {
          this.castCreate = false;
        }
        if (
          element.PageName == 'Caste Wise Intake' &&
          element.PUpdate == false
        ) {
          this.castUpdate = false;
        }
      });
    }
    this.showCount = false;
    this.istableShow = false;
    this.buttonDisabled = false;
    this.showErr = false;
    this.submitButton = true;
    this.updateButton = false;
    this.arr = [];
    this.castIntake = this.fb.group({
      CollegeCastArr: this.fb.array([]),
      SessionID: new FormControl('', [Validators.required]),
      CgCode: new FormControl('', [Validators.required]),
      CoCode: new FormControl('', [Validators.required]),
    });
    let idd = '';
    this.fetchSession(idd);
    this.fetchCast();
  }

  addNewRow(data) {
    const creds = this.castIntake.controls.CollegeCastArr as FormArray;
    creds.clear();
    if (data == '') {
      creds.push(
        this.fb.group({
          Caste: new FormControl('', [Validators.required]),
          RecongnizedIntake: new FormControl(''),
          PermittedIntake: new FormControl(''),
        })
      );
    } else {
      data.forEach((element, i) => {
        if (
          (element.Caste == '' || element.Caste == null) &&
          (element.RecongnizedIntake == '' ||
            element.RecongnizedIntake == null) &&
          (element.PermittedIntake == '' || element.PermittedIntake == null)
        ) {
          this.submitButton = true;
          this.updateButton = false;
          creds.push(
            this.fb.group({
              Caste: new FormControl('', [Validators.required]),
              RecongnizedIntake: new FormControl(''),
              PermittedIntake: new FormControl(''),
            })
          );
        } else {
          this.submitButton = false;
          this.updateButton = true;
          creds.push(
            this.fb.group({
              Caste: new FormControl(element.Caste, [Validators.required]),
              RecongnizedIntake: new FormControl(element.RecongnizedIntake),
              PermittedIntake: new FormControl(element.PermittedIntake),
            })
          );
        }
      });
    }
  }

  addNewRow2(i, e) {
    if (this.getTotalCount() > this.inteckCount) {
      // If total permitted intake exceeds or equals the limit, return without adding a new row
      this.buttonDisabled = true;
      this.showErr = true;
      this.Message =
        'Selected Course And College Intake Is Less Than Cast Wise Intake';
      return;
    }
    this.arr = this.castIntake.controls.CollegeCastArr.value;
    this.CollegeCastArr = this.castIntake.get('CollegeCastArr') as FormArray;
    if (this.CollegeCastArr.invalid) {
      this.CollegeCastArr.controls.forEach((element) => {
        element.get('Caste').markAsTouched();
        element.get('RecongnizedIntake').markAsTouched();
        element.get('PermittedIntake').markAsTouched();
      });
    } else {
      // this.lvl = this.castIntake.controls.CollegeCastArr.value.length
      this.arr = this.castIntake.controls.CollegeCastArr.value;
      const creds = this.castIntake.controls.CollegeCastArr as FormArray;
      creds.push(
        this.fb.group({
          Caste: new FormControl('', Validators.required),
          RecongnizedIntake: new FormControl('', Validators.required),
          PermittedIntake: new FormControl('', Validators.required),
        })
      );
    }
  }

  deleteRow(index) {
    if (index !== 0) {  //if selected row for delete is greater than 0 then delete can happen
      (<FormArray>this.castIntake.get('CollegeCastArr')).removeAt(index);
      this.arr = this.castIntake.controls.CollegeCastArr.value;
      this.CollegeCastArr = this.castIntake.controls.CollegeCastArr.value.length;
      const data = this.castIntake.controls.CollegeCastArr.value;
      data.forEach((element, i) => {
        this.CollegeCastArr = this.castIntake.get(
          'CollegeCastArr'
        ) as FormArray;
      });
      this.arr = this.castIntake.controls.CollegeCastArr.value;
    } else {
      let data = {};
      data['message'] = 'First Row Can Not Be Deleted';
      data['title'] = 'Information';
      data['icon'] = 'fas fa-check';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
        AlertBoxComponent,
        data
      );
    }
  }

  duplicateCheck(Caste, i) {  //to check if the selected caste has already given intake
    this.arr.forEach((element) => {
      if (element.Caste == Caste.CdCode) {
        let data = {};
        data['message'] = 'Caste Already Selected';
        data['title'] = 'Information';
        data['icon'] = 'fas fa-box-open';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
        // this.arrry = this.feeTempletForm.controls.feeHeadArray as FormArray;
        this.arrayy = this.castIntake.get('CollegeCastArr') as FormArray;
        this.arrayy.at(i).get('Caste').setValue('');
      } else {
        this.arr = this.castIntake.controls.CollegeCastArr.value;
      }
    });
  }

  getControls() {
    return (this.castIntake.get('CollegeCastArr') as FormArray).controls;
  }

  fetchCast() {
    this.spinner.show()
    const payload = {};
    this.categoryList = [];
    this.filteredCategoryList = [];
    payload['CdType'] = 'CS';
    this.umsService.getCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
        this.categoryList = res.data;
        this.filteredCategoryList = this.categoryList.slice();
        //this.castGene(payload)
      } else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }

  fetchSession(id) {
    this.spinner.show()
    const payload = {};
    payload['SnDefault'] = id;
    payload['SnNo'] = id;
    this.umsService.getSession(payload).subscribe((res) => {
      this.sessionList = [];
      if (res.status) {
        this.spinner.hide()
        res.data.forEach((element) => {
          if (element.SnStatus == 'O') {
            this.sessionList.push(element);
          }
        });
        this.SessionFilterList = this.sessionList.slice();
      }
      else{
        this.spinner.hide()
      }
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }

  fetchCollege() {
    this.spinner.show()
    const payload = {};
    this.umsService.getCollege(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
        this.collegeList = res.data;
        this.filteredCollegeList = this.collegeList.slice();
        this.castIntake.controls['college'].setValue('');
      } else {
        this.spinner.hide()
        // this.apimicroservice.openSnackbar(res.message);
      }
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }

  save() {
    this.CollegeCastArr = this.castIntake.get('CollegeCastArr') as FormArray;
    if (this.castIntake.invalid) {
      this.castIntake.get('SessionID').markAsTouched();
      this.castIntake.get('CgCode').markAsTouched();
      this.castIntake.get('CoCode').markAsTouched();
    }
    if (this.castIntake.invalid) {
      this.CollegeCastArr.controls.forEach((element) => {
        element.get('Caste').markAsTouched();
        element.get('RecongnizedIntake').markAsTouched();
        element.get('PermittedIntake').markAsTouched();
      });
    } else {
      this.submit();
    }
  }

  update() {
    this.CollegeCastArr = this.castIntake.get('CollegeCastArr') as FormArray;
    if (this.castIntake.invalid) {
      this.castIntake.get('SessionID').markAsTouched();
      this.castIntake.get('CgCode').markAsTouched();
      this.castIntake.get('CoCode').markAsTouched();
    }
    if (this.castIntake.invalid) {
      this.CollegeCastArr.controls.forEach((element) => {
        element.get('Caste').markAsTouched();
        element.get('RecongnizedIntake').markAsTouched();
        element.get('PermittedIntake').markAsTouched();
      });
    } else {
      this.submit1();
    }
  }

  submit1() {
    this.spinner.show();
    let payload = {};
    payload = this.castIntake.value;
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: {
        SessionID: payload['SessionID'],
        CgCode: payload['CgCode'],
        CoCode: payload['CoCode'],
        Caste: payload['CollegeCastArr'][0]['Caste'],
        RecongnizedIntake: payload['CollegeCastArr'][0]['RecongnizedIntake'],
        PermittedIntake: payload['CollegeCastArr'][0]['PermittedIntake'],
      },
    };
    this.spinner.hide();
    this.httpClient
      .delete(this.APIService + '/students/CastewiseIntake', options)
      .subscribe(
        (s) => {
          let cc = [];
          cc.push(s);
          this.submit();
        },
        (ERROR: HttpErrorResponse) => {}
      );
  }

  update1() {
    this.spinner.show();
    let payload = {};
    payload = this.castIntake.value;
    let iserror = false;
    var bar = new Promise<void>((resolve, reject) => {
      payload['CollegeCastArr'].forEach((element, index, array) => {
        let arr1 = [];
        arr1.push(
          this.fb.group({
            SessionID: new FormControl(payload['SessionID']),
            CgCode: new FormControl(payload['CgCode']),
            CoCode: new FormControl(payload['CoCode']),
            Caste: new FormControl(element['Caste']),
            RecongnizedIntake: new FormControl(
              parseInt(element['RecongnizedIntake'])
            ),
            PermittedIntake: new FormControl(
              parseInt(element['PermittedIntake'])
            ),
          })
        );
        this.umsService.updateCastSessionCutOff(arr1[0].value).subscribe(
          (res) => {
            this.spinner.hide();
            if (res.status == false) {
              iserror = true;
              this.errMsg = res.message;
            }
            if (index === array.length - 1) resolve();
            else {
              iserror = false;
              this.errMsg = res.message;
              // this.NewCoSch();  disabled automatic course schedule api calls as discussed on 21/02/24
            }
            if (res.status == true) {
              iserror = false;
              this.errMsg = res.message;
              // this.NewCoSch();  disabled automatic course schedule api calls as discussed on 21/02/24
            }
          },
          (ERROR: HttpErrorResponse) => {
            this.spinner.hide();
            iserror = true;
            this.errMsg = ERROR.error.message;
            if (index === array.length - 1) resolve();
          }
        );
      });
    });
    bar.then(() => {
      if (iserror == false) {
        let data = {};
        data['message'] = 'Submitted Successfully';
        data['title'] = 'Information';
        data['icon'] = 'fas fa-check';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
        this.dialogRef.afterClosed().subscribe((result) => {
          this.ngOnInit();
        });
      } else {
        let data = {};
        data['message'] = this.errMsg;
        data['title'] = 'Alert';
        data['icon'] = 'fas fa-close';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
        // this.ngOnInit();
      }
    });
  }

  submit() {
    this.spinner.show();
    let payload = {};
    payload = this.castIntake.value;
    let iserror = false;
    var bar = new Promise<void>((resolve, reject) => {
      payload['CollegeCastArr'].forEach((element, index, array) => {
        let arr1 = [];
        arr1.push(
          this.fb.group({
            SessionID: new FormControl(payload['SessionID']),
            CgCode: new FormControl(payload['CgCode']),
            CoCode: new FormControl(payload['CoCode']),
            Caste: new FormControl(element['Caste']),
            RecongnizedIntake: new FormControl(
              parseInt(element['RecongnizedIntake'])
            ),
            PermittedIntake: new FormControl(
              parseInt(element['PermittedIntake'])
            ),
          })
        );
        this.umsService.addCastSessionCutOff(arr1[0].value).subscribe(
          (res) => {
            this.spinner.hide();
            if (res.status == false) {
              iserror = true;
              this.errMsg = res.message;
            }
            if (index === array.length - 1) resolve();
            else {
              iserror = false;
              this.errMsg = res.message;
            }
            if (res.status == true) {
              iserror = false;
              this.errMsg = res.message;
            }
          },
          (ERROR: HttpErrorResponse) => {
            this.spinner.hide();
            iserror = true;
            this.errMsg = ERROR.error.message;
            if (index === array.length - 1) resolve();
          }
        );
      });
    });
    bar.then(() => {
      if (iserror == false) {
        let data = {};
        data['message'] = 'Submitted Successfully';
        data['title'] = 'Information';
        data['icon'] = 'fas fa-check';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
        this.dialogRef.afterClosed().subscribe((result) => {
          // this.ngOnInit();
        });
      } else {
        let data = {};
        data['message'] = this.errMsg;
        data['title'] = 'Alert';
        data['icon'] = 'fas fa-close';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
        // this.ngOnInit();
      }
    });
  }

  getCount(CgCode, id) {
    this.spinner.show()
    const payload = {};
    payload['CoCgCgCode'] = id.CgCode ? id.CgCode : id.CoCgCgCode;
    payload['SessionID'] = sessionStorage.getItem('SessId');
    this.umsService.getSessionColgCo(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
        this.showCount = true;
        this.CountTable = res.data;
        this.inteckCount = res.data[0].PermittedIntake;
      } else {
        this.spinner.hide()
        if (res.message == 'No Data Found') {
          this.CountTable = [];
          this.showCount = false;
        }
      }
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });

    this.getTable(CgCode);
  }

  getTable(CgCode) {
    this.spinner.show();
    this.istableShow = true;
    this.submitButton = true;
    const payload = {};
    (payload['SessionID'] = this.sessionId), (payload['CgCode'] = CgCode);
    (payload['CoCode'] = this.CoCode),
      this.umsService.getSessionIntakeCutoff(payload).subscribe((res) => {
        if(res.status){
          this.spinner.hide()
          this.tableData = res.data;
          this.addNewRow(this.tableData);
        }
        else{
          this.spinner.hide()
        }
        },
        (ERROR: HttpErrorResponse) => {
          this.spinner.hide();
          let data = {};
          data['message'] = ERROR.error.message;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-close';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
        }
      );
  }

  getCourse(id) {
    this.spinner.show();
    this.showCount = false;
    this.istableShow = false;
    this.buttonDisabled = false;
    this.showErr = false;
    this.filteredCourseList = [];
    this.filteredCollegeList = [];
    this.courseList = [];
    this.sessionId = id;
    const payload = {};
    payload['SessionId'] = id;
    this.umsService.fetchIntakeFilter(payload).subscribe(
      (res) => {
        if (res.status) {
          this.spinner.hide();
          this.courseList = res.data;
          this.filteredCourseList = this.courseList.slice();
        } else {
          this.spinner.hide();
          this.courseList = [];
          this.filteredCourseList = [];
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.courseList = [];
      }
    );
  }

  getClg(CoCode) {
    this.spinner.show();
    this.showCount = false;
    this.istableShow = false;
    this.buttonDisabled = false;
    this.showErr = false;
    this.CoCode = CoCode;
    const payload = {};
    payload['SessionId'] = this.sessionId;
    payload['CoCgCoCode'] = CoCode;
    this.umsService.fetchIntakeFilter(payload).subscribe((res) => {
        if(res.status){
          this.spinner.hide();
          this.collegeList = res.data;
          this.filteredCollegeList = this.collegeList.slice();
        }
        else{
          this.spinner.hide()
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.collegeList = [];
      }
    );
  }

  onInputChange(event: any, i) {
    clearTimeout(this.inputTimeout);
    (this.inputTimeout = setTimeout(() => {
      this.getTotalCount();
    })),
      500;
  }

  getTotalCount() { //
    const tempData = this.castIntake.controls.CollegeCastArr.value;
    this.arrTest = tempData;
    let totalCount = 0;
    tempData.forEach((element, i) => {
      if (element.PermittedIntake == '') {
        element.PermittedIntake = 0;
      }
      totalCount = totalCount + parseInt(element.PermittedIntake);
      if (totalCount > this.inteckCount) {
        this.buttonDisabled = true;
        this.showErr = true;
        this.Message =
          'Selected Course And College Intake Is Less Than Cast Wise Intake';
      } else {
        this.Message = '';
        this.buttonDisabled = false;
        this.showErr = false;
      }
    });
    return totalCount;
  }

}